module.exports = __webpack_public_path__ + "img/2024-02-13c_3.a2d930e5.jpg";